module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Nose Art B-17G style: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sentimental Journey")]), _vm._v(" photographed at Paine Field, USA 2011. (John Veit)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The ‘Flying Fortress’, a term coined by a Seattle Daily Times report in 1935, was a quantum leap in offensive air power. Designed for a nation whose foreign policy was still deeply isolationist, and for an Air Corps whose in-service bomber fleet was dominated by bi-plane types, the B-17 was something from the Flash Gordon films. With its four engines, huge wingspan, enviable payload (almost double that of contemporary bombers) and all-metal construction, the B-17 ushered in a new age. By the time the United States had entered the war in December 1941, the B-17 was already in service with the RAF. Soon after the 8th Air Force arrived and new airfields appeared all over the South of England. In the North African Deserts the Ninth Air Force joined the RAF’s Middle East Command in harrying retreating Panzerarmée Afrika Forces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the first USAAF Boeing B-17Es landed at High Wycombe on 12 May 1942 they marked a pivotal moment in the air war over Europe. While the B-17 was no stranger to Britain’s shores, as the RAF had been using the B-17C since mid-1941, it was arriving to fulfil a different mission. Now the B-17 was massing in numbers with it crews, whose way of doing things was very different to the RAF’s. Quickly the USAAF took on the role of daytime bombing raids, led by the sleek B-17, while the RAF was tasked with night bombing led by the business-like Trinity of the Halifax, Lancaster and Sterling. The air war was now operational for twenty-four hours, seven days a week.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/img2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A fine underside study of the B-17G in formation. Note the staggered waist gun positions. (USAF)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The B-17 was soon flying over Europe with the newly created United States Army Air Forces, as well as taking the fight to the Japanese in the Pacific and the Axis in the Mediterranean. No matter what enemy air defences threw at the B-17, it soon began to live up to its name and earned a reputation for surviving all but the most catastrophic of damage. The newly formed USAAF crews helped make the B-17 an icon in its own service life, with glistening fuselages replacing the drab-coloured airframes of earlier service life. It also boasts a range of unique finishes including eye-catching nose art, often reflected on both air and ground crew jackets.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/img3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An early B-17, possibly at Will Rogers Field, Oklahoma City 1944, prepares for take-off. (Bond Collection/ USAF)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/img4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Boeing B-17F "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("All American III")]), _vm._v(" of the 97th Bomb Group, 414th Bomb Squadron, in flight after a collision with an Me109. The aircraft returned to base. (USAF)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/img5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Ground crew of the 92nd Bomb Group prepares a B-17F "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boomerang")]), _vm._v(" for operations at RAF Bovingdon. (USAAF)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The youthful crews, marked by relaxed camaraderie on the ground, showed remarkable bravery and élan in the face of growing and vicious assaults by increasingly sophisticated aircraft, including the notorious FW190 ‘Murder Bird’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By D-Day the B-17G was the main version in use, flown in natural metal (which saved around two tonnes of paint) and enjoying ever-increasing fighter protection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The B-17 carried the top secret Norden Bomb Sight which had a phenomenal circular error probable of 75ft which would allow for accurate high-altitude bombing. The Norden was also unique in that it allowed the bombardier to fine tune the aircraft’s flight from auto-pilot once he’d started his bomb run. It was for accurate daylight bombing that the B-17, its crews and ever-upgraded performance and armament, were designed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The B-17 was employed in a range of vital roles, from the projection of air power to meteorological surveys it was an exceedingly capable aircraft. Operated by the Strategic Air Forces in Europe, who undertook some of the most dangerous daylight bombing missions over enemy territory, the B-17 helped in a concerted effort to disrupt and destroy enemy oil production and rail networks. It was in this theatre that many of the legends and characters of the Eighth were formed, such as the ‘Memphis Belle’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time production stopped in April 1945, the B-17 had become the master of the air in the daylight heavy bomber war over Europe but had been supplanted by the B-24 in the Pacific. It would bow out as a bomber not long after the war’s end with the introduction of the B-29 and the advent of nuclear weapons. A few B-17s would soldier on as SB-17 air-sea rescue aircraft and serve in other nations around the world in the early Cold War era. Ultimately the B-17 would fly with twenty-six countries including Germany, Russia and Japan. By the war’s end over 12,700 B-17s had been built, and with that an evergreen legend.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74fae2b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Introduction.vue
// module id = 72
// module chunks = 0